const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${BACKEND}/api/files/${path}`;
};

export const initials = (name = "") =>
  name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();
